import React, { useCallback } from 'react';

import { useOrderContext, useOrderDispatch } from '@/components/modals/SubmitOrder/helpers';

import { ContractDetailsWrapper } from '../ContractDetailsWrapper';
import { SectionToggler } from '../SectionToggler';

export const Financing = (): JSX.Element => {
  const state = useOrderContext();
  const dispatch = useOrderDispatch();
  const handleOnChange = useCallback(
    (value: boolean) => {
      dispatch({
        type: 'UPDATE_ORDER',
        payload: {
          isFinancingIncluded: value,
        },
      });
    },
    [dispatch],
  );

  const getToggleStatus = () => {
    if (state.order.isFinancingIncluded) {
      return true;
    }

    if (state.order.isFinancingIncluded === null) {
      return null;
    }

    return false;
  };

  return (
    <ContractDetailsWrapper tabletView title="Would you like to include financing?">
      <SectionToggler
        enabled={getToggleStatus()}
        name="include-financing"
        onToggle={handleOnChange}
        verticalMobileLayout
      />
    </ContractDetailsWrapper>
  );
};
